import type { BoxProps } from '@withjoy/joykit';
import React from 'react';
import { usePeekSize } from './RecommendationsCarousel.controller';
import { StyledContainer, StyledContent, StyledHeaderContainer as StyledHeader, StyledHeaderEnd, StyledHeaderStart, styles } from './RecommendationsCarousel.styles';

const RecommendationsCarousel = React.forwardRef<HTMLDivElement, BoxProps>(({ children, ...restProps }, ref) => {
  return (
    <StyledContainer
      ref={ref}
      {...restProps}
    >
      {children}
    </StyledContainer>
  );
});

const Content: React.FC<BoxProps> = ({ children, ...restProps }) => {
  return (
    <StyledContent
      {...restProps}
      __css={styles.content}
    >
      {children}
    </StyledContent>
  );
};

const Header: React.FC<BoxProps & { enablePeek?: boolean }> & {
  Start: typeof HeaderStart;
  End: typeof HeaderEnd;
} = ({ children, ...restProps }) => {
  const { enablePeek } = restProps;
  const { peekSize } = usePeekSize({ enablePeek });

  return (
    <StyledHeader
      {...restProps}
      __css={styles.header(peekSize)}
    >
      {children}
    </StyledHeader>
  );
};

const HeaderStart: React.FC<BoxProps> = ({ children, ...restProps }) => {
  return (
    <StyledHeaderStart
      {...restProps}
      __css={styles.headerStart}
    >
      {children}
    </StyledHeaderStart>
  );
};

const HeaderEnd: React.FC<BoxProps> = ({ children, ...restProps }) => {
  return (
    <StyledHeaderEnd
      {...restProps}
      __css={styles.headerEnd}
    >
      {children}
    </StyledHeaderEnd>
  );
};

Header.Start = HeaderStart;
Header.End = HeaderEnd;

export { Content, Header, RecommendationsCarousel };
